import SecureBaseModel from './SecureBaseModel';

class InfoModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static SHOP_INFO = 'shop-info';

    constructor() {
        super();
    }

    async getInfo(params) {
        return await this.postData(InfoModel.SHOP_INFO, params);
    }
}

export default InfoModel;
